
(function () {
    window.cart = null;

    async function loadCart() {
        const res = await fetch('/cart.js');
        window.cart = await res.json();

        document.dispatchEvent(new CustomEvent('cart:loaded', {
            detail: { cart: window.cart }
        }));
    }

    async function updateCart(endpoint, payload, eventName) {
        const res = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        window.cart = await res.json();

        document.dispatchEvent(new CustomEvent(eventName, {
            detail: { cart: window.cart, payload }
        }));

        document.dispatchEvent(new CustomEvent('cart:changed', {
            detail: { cart: window.cart }
        }));
    }

    window.Cart = {

        refresh() {
            return loadCart();
        },

        add(variantId, quantity = 1) {
            return updateCart('/cart/add.js', {
                id: variantId,
                quantity
            }, 'cart:item-added');
        },

        change(lineItemKey, quantity) {
            return updateCart('/cart/change.js', {
                id: lineItemKey,
                quantity
            }, 'cart:item-changed');
        },

        remove(lineItemKey) {
            return updateCart('/cart/change.js', {
                id: lineItemKey,
                quantity: 0
            }, 'cart:item-removed');
        },

        clear() {
            return updateCart('/cart/clear.js', {}, 'cart:cleared');
        }
    };

    loadCart();
})();
